import { createFileRoute } from '@tanstack/react-router'

import { PlatformMigrationPage } from '../../../components/pages/backoffice/platform/platform-migration-page/platform-migration-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/migration')({
  component: () => (
    <PermissionChecker requiredPermissions={['subscription.changeOwner']}>
      <PlatformMigrationPage />
    </PermissionChecker>
  ),
})
